import { makeStyles, Theme, createStyles, withStyles } from '@material-ui/core/styles';
import { InputBase } from '@material-ui/core';
export const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(3),
    backgroundColor: '#f5f7fb',
    minHeight: '100vh',
  },
     noBorder: {
      border: 'none',
    },
  title: {
    fontSize: '28px',
    fontWeight: 700,
    marginBottom: theme.spacing(3),
    color: '#111827',
  },
  controls: {
    marginBottom: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },
  box: {
    marginBottom: theme.spacing(2),
    width: '100%',
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: theme.spacing(1),
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      width: '100%',
      justifyContent: 'space-between',
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      width: '100%',
      gap: theme.spacing(1),
    },
  },
  filterSection: {
    marginBottom: theme.spacing(4),
    padding: theme.spacing(3),
    backgroundColor: 'white',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  },
  filterRow: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  formControl: {
    minWidth: 150,
  },
  dateField: {
    minWidth: 180,
  },
  statsCard: {
    padding: theme.spacing(3),
    textAlign: 'center',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    transition: 'transform 0.2s',
    '&:hover': {
      transform: 'translateY(-2px)',
    },
  },
  statsIcon: {
    fontSize: '48px',
    marginBottom: theme.spacing(1),
  },
  statsValue: {
    fontSize: '32px',
    fontWeight: 700,
    color: '#111827',
  },
  statsLabel: {
    fontSize: '14px',
    color: '#6b7280',
    marginTop: theme.spacing(1),
  },
  chartContainer: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(3),
    backgroundColor: 'white',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  },
  chartTitle: {
    fontSize: '18px',
    fontWeight: 600,
    marginBottom: theme.spacing(2),
    color: '#111827',
  },
  tableContainer: {
    marginTop: theme.spacing(3),
    backgroundColor: 'white',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  },
  tableTitle: {
    padding: theme.spacing(3),
    fontSize: '18px',
    fontWeight: 600,
    color: '#111827',
    borderBottom: '1px solid #e5e7eb',
  },
  applyButton: {
    backgroundColor: '#1976d2',
    color: 'white',
    padding: '10px 24px',
    '&:hover': {
      backgroundColor: '#1565c0',
    },
  },
  chartBar: {
    height: '20px',
    borderRadius: '4px',
    marginBottom: theme.spacing(1),
  },
  chartItem: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1),
  },
  progressContainer: {
    marginBottom: theme.spacing(1),
  },
  progressLabel: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(0.5),
    fontSize: '14px',
  },
  tabs: {
    width: 'fit-content',
    border: '1px solid white',
    borderRadius: '4px 0px 0px 4px',
    background: 'white',
    '& .MuiTabs-indicator': {
      backgroundColor: 'orange',
      height: 3,
    },
    '& .MuiTab-root.Mui-selected': {
      color: 'white',
      backgroundColor: '#5081FF',
    },
    '& .MuiTab-root': {
      padding: '16px 24px',
    },
  },
  label: {
    minWidth: 'auto',
    maxWidth: 'inherit',
    padding: 0,
    fontWeight: 500,
    fontSize: 14,
  },
  tabBox: {
    // backgroundColor: '#ffffff',
    // marginTop: theme.spacing(2.5),
  },
}));
export const BootstrapInput = withStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      [theme.breakpoints.down('sm')]: {
        margin: theme.spacing(0.5, 0),
      },
    },

    input: {
      width: '200px',
      padding: '16px 16px',
      marginLeft: theme.spacing(1),
      borderRadius: 4,
      position: 'relative',
      background: '#fff',
      fontSize: 14,
      [theme.breakpoints.down('md')]: {
        width: '180px',
        padding: '14px 12px',
        fontSize: 13,
      },
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        marginLeft: 0,
        padding: '12px 10px',
        fontSize: 12,
      },
      [theme.breakpoints.down('xs')]: {
        padding: '10px 8px',
        fontSize: 11,
      },
    },
  })
)(InputBase);
